import React from 'react';
import { animateScroll } from 'react-scroll';
import Dashboard from '../generic-dashboard';

const QualifyDashboard = ({ children, ...props }) => {
  animateScroll.scrollToTop({
    duration: 0,
    delay: 0,
    smooth: false
  });
  return (
    <Dashboard
      message="Thanks! That's all the information we need for now."
      articles={[
        {
          href: '7-reasons-only-1-in-4-homebuyers-shop-for-a-mortgage',
          title: '7 Reasons Only 1 in 4 Homebuyers Shop for a Mortgage'
        },
        {
          href: 'decoding-mortgage-jargon',
          title: 'Decoding Mortgage Jargon'
        },
        {
          href: 'the-5-dangers-of-mortgage-calculators',
          title: 'The 5 Dangers of Mortgage Calculators'
        }
      ]}
      props={props}
    >
      {children}
    </Dashboard>
  );
};

export default QualifyDashboard;



// WEBPACK FOOTER //
// ./src/products/shared/qualify/dashboard.js